import * as types from '@/store/types.js'
import router from '@/router'
import store from '@/store/index'
import displayError from '@/helpers/displayError'
import app from '../main'

export default {
  baseUrl () {
    return 'categories'
  },

  index (request) {
    return axios.get(this.baseUrl(), { params: request })
  },

  show (id, request) {
    return axios.get(`${this.baseUrl()}/${id}`, {params: request})
  },

  create (request) {
    return axios.post(`${this.baseUrl()}`, {
      category: request
    }).then((response) => {
      app.$snotify.success('Successfully created.')
      store.dispatch(types.ADD_CATEGORY, response.data.data)
      router.push({ name: `${this.baseUrl()}.edit`, params: { id: response.data.data.id } })
    }).catch((error) => {
      displayError(error)
    })
  },

  update (request) {
    return axios.put(`${this.baseUrl()}/${request.id}`, {
      category: request
    }).then((response) => {
      app.$snotify.success('Successfully updated.')
    }).catch((error) => {
      displayError(error)
    })
  },

  delete (request) {
    return axios.delete(`${this.baseUrl()}/${request.id}`)
  }
}



// WEBPACK FOOTER //
// ./src/model/Category.js